import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

const useFullscreenImage = (): string | undefined => {
  const lastbotActivity = useSelector((state: RootState) => state.activityReducer.lastBotActivity)
  const fullScreenImage = useSelector((state: RootState) => state.utilsReducer.fullScreenImage)
  const [image, setImage] = useState<string | undefined>(undefined)

  useEffect(() => {
    setImage(fullScreenImage)
  }, [fullScreenImage])

  useEffect(() => {
    if (lastbotActivity && lastbotActivity.type === 'event' && lastbotActivity.name === 'hospitality.ShowImage' && lastbotActivity.value) {
      setImage(lastbotActivity.value)
    } else {
      setImage(undefined)
    }
  }, [lastbotActivity])

  return image
}

export default useFullscreenImage
